export const MediaQuery = {
  XS: "@media (max-width: 540px)",
  SM: "@media (min-width: 740px)",
  MD: "@media (min-width: 960px)",
  LG: "@media (min-width: 1340px)",
  XL: "@media (min-width: 1400px)",
  XXL: "@media (min-width: 1400px)",
};
